import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusIcon',
  props: {
    value: { type: Boolean },
    size: { default: 10 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["icon", _ctx.value?.toString()]),
    style: _normalizeStyle({ width: _ctx.size + 'px', height: _ctx.size + 'px' })
  }, null, 6))
}
}

})